import { Component, OnInit } from '@angular/core';
import {AgRendererComponent} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";
import { canOpenIntegrationDetails, IntegrationRef } from '../app.model';
import { IntegrationSource } from '../services/integration-table/integration-table.service';
//import {AppService} from '../app.service';

@Component({
  selector: 'app-full-width-cell-renderer',
  templateUrl: './full-width-cell-renderer.component.html',
  styleUrls: ['./full-width-cell-renderer.component.scss'],
  // host: {
  //   '(document:click)': '',
  // }
})
export class FullWidthCellRendererComponent implements AgRendererComponent {

  public params: ICellRendererParams;
  isDestination: boolean
  status:any;
  warehouses: any
  destlogoUrl: string;
  focusIndex: number;
  userId;
  isOrgAdmin;
  baseWord;
  gridLength: number;
  rowIndex;
  innerClicked: any;
  rootUserId: number;
  isDestinationSet: boolean;
  groupName: string;
  integrationDetailsDisabled = false;

  // constructor(
  //   private appService: AppService) {
  //     this.appService.closeSourceDetinationDropDown().subscribe({
  //       next: value => { // console.log(value,"LLLLLLL")
  //         this.status = false
  //       }
  //     });
  //   }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.innerClicked = false;
    this.warehouses = this.params.data['warehouses'];
    this.destlogoUrl = this.params.value;
    this.userId = this.params['userId'];
    this.rootUserId = this.params.data['rootUserId'];
    this.isOrgAdmin = this.params.data['isOrgAdmin'];
    this.baseWord = this.params.data['baseWord'];
    this.isDestination = this.params['isDestination'];
    this.gridLength = this.params['gridLength'];
    this.rowIndex = this.params.node ? this.params.node.rowIndex : 0;
    this.isDestinationSet = this.params.data['destinationName'] != null;
    this.groupName = this.params.data['groupName'];
    this.integrationDetailsDisabled = !canOpenIntegrationDetails(
      this.params?.data?.status,
      this.isDestinationSet
    );
  }

  refresh(): boolean {
    return false;
  }

  routeToDetails() {
    if (this.isDestinationSet) {
      const integration: IntegrationRef = {
        integrationName: this.params.data.integrationName,
        sourceId: this.params.data.sourceId,
        status: this.params.data.status,
        destinationName: this.params.data.destinationName
      };
      this.params.context.componentParent?.routeToDetails?.(integration);
    }
  }

  routeToDest() {

    this.status = !this.status
    this.params.context.componentParent
    .routeToDest( this.params.data.sourceId, this.params.data.userId);

  }

  setWarehouse() {
    this.status = !this.status
    this.params.context.componentParent
    .setWarehouse(this.params.data.warehouses[this.focusIndex].warehouseId, this.params.data.sourceId, this.params.data.userId);

  }

  onChangeSourceStatus(sourceId,actionType ,flag, sourceType, dataSourceId) {

    this.params.context.componentParent.onChangeSourceStatus(sourceId, actionType, flag, sourceType, dataSourceId);

  }

  startSource(data) {

    this.params.context.componentParent.startSource(data)
    setTimeout(()=>{
      this.innerClicked = false
    },500)
  }

  toggleDropDown(sourceId , status) {
    //  console.log("hello")
      this.params.context.componentParent.toggleDropDown(sourceId, status)

      setTimeout(() => {
        this.innerClicked = false;
      }, 500)

    }

  getTables(data: IntegrationSource) {
    if (this.params?.context?.componentParent?.getTables) {
      this.params.context.componentParent.getTables(data);
    }
  }
}
